var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconicQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6268_18860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1952 9.83008C20.2607 10.2511 21.2173 10.9077 21.9931 11.7507C22.7689 12.5938 23.344 13.6014 23.6752 14.6982C24.0065 15.795 24.0853 16.9525 23.9057 18.084C23.7262 19.2156 23.293 20.2919 22.6386 21.2323L23.9985 24.4985L20.7323 23.1386C19.792 23.7931 18.7158 24.2263 17.5843 24.4059C16.4528 24.5855 15.2953 24.5068 14.1985 24.1757C13.1017 23.8446 12.0941 23.2697 11.251 22.494C10.4079 21.7182 9.75119 20.7618 9.33008 19.6964C9.41967 19.698 9.5094 19.6988 9.59926 19.6988C12.1452 19.6988 14.5869 18.6874 16.3871 16.8871C18.1874 15.0869 19.1988 12.6452 19.1988 10.0993C19.1988 10.0091 19.1976 9.91941 19.1952 9.83008Z",
    fill: "url(#paint0_linear_6268_18860)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87351 14.9106L1.80862 15.1215L0.728532 18.6316L4.51619 17.8198L4.71034 17.7782L4.88014 17.8811C6.08066 18.6088 7.43327 19.0489 8.83215 19.1668C10.231 19.2848 11.6382 19.0775 12.9437 18.5612C14.2491 18.0449 15.4174 17.2335 16.3571 16.1906C17.2968 15.1476 17.9825 13.9014 18.3604 12.5494C18.7384 11.1974 18.7984 9.77629 18.5358 8.39724C18.2732 7.01818 17.695 5.71858 16.8466 4.60013C15.9982 3.48167 14.9025 2.57468 13.6452 1.95013C12.388 1.3256 11.0033 1.00041 9.59956 1L1.87351 14.9106ZM1.87351 14.9106L1.76146 14.7206M1.87351 14.9106L1.76146 14.7206M1.76146 14.7206C0.946778 13.3386 0.511927 11.7658 0.500983 10.1616C0.490039 8.5574 0.903392 6.97882 1.69914 5.58586C2.4949 4.1929 3.64477 3.03506 5.0322 2.22972C6.41959 1.4244 7.99521 1.00016 9.59938 1L1.76146 14.7206Z",
    fill: "url(#paint1_linear_6268_18860)",
    stroke: "#EEF9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9992 18.8992C20.441 18.8992 20.7991 18.5411 20.7991 18.0993C20.7991 17.6575 20.441 17.2993 19.9992 17.2993C19.5574 17.2993 19.1992 17.6575 19.1992 18.0993C19.1992 18.5411 19.5574 18.8992 19.9992 18.8992Z",
    fill: "#E2E7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5988 18.8992C18.0406 18.8992 18.3987 18.5411 18.3987 18.0993C18.3987 17.6575 18.0406 17.2993 17.5988 17.2993C17.157 17.2993 16.7988 17.6575 16.7988 18.0993C16.7988 18.5411 17.157 18.8992 17.5988 18.8992Z",
    fill: "#E2E7F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.999 8.89972C13.999 8.4754 13.8305 8.06845 13.5304 7.76841C13.2304 7.46837 12.8234 7.2998 12.3991 7.2998H11.9991C11.5748 7.2998 11.1679 7.46837 10.8678 7.76841C10.5678 8.06845 10.3992 8.4754 10.3992 8.89972V10.8996C10.3992 11.6422 10.6942 12.3543 11.2193 12.8794C11.7443 13.4045 12.4565 13.6995 13.1991 13.6995C13.4112 13.6995 13.6147 13.6152 13.7647 13.4652C13.9147 13.3152 13.999 13.1117 13.999 12.8995C13.999 12.6874 13.9147 12.4839 13.7647 12.3339C13.6147 12.1838 13.4112 12.0996 13.1991 12.0996C12.8808 12.0996 12.5756 11.9731 12.3506 11.7481C12.1255 11.5231 11.9991 11.2179 11.9991 10.8996C11.9991 10.7935 12.0413 10.6918 12.1163 10.6168C12.1913 10.5418 12.293 10.4996 12.3991 10.4996C12.8234 10.4996 13.2304 10.3311 13.5304 10.031C13.8305 9.731 13.999 9.32405 13.999 8.89972ZM8.79928 8.89972C8.79928 8.4754 8.63072 8.06845 8.33068 7.76841C8.03063 7.46837 7.62369 7.2998 7.19936 7.2998H6.79938C6.37506 7.2998 5.96811 7.46837 5.66807 7.76841C5.36803 8.06845 5.19946 8.4754 5.19946 8.89972V10.8996C5.19946 11.6422 5.49445 12.3543 6.01952 12.8794C6.5446 13.4045 7.25676 13.6995 7.99932 13.6995C8.21149 13.6995 8.41496 13.6152 8.56498 13.4652C8.715 13.3152 8.79928 13.1117 8.79928 12.8995C8.79928 12.6874 8.715 12.4839 8.56498 12.3339C8.41496 12.1838 8.21149 12.0996 7.99932 12.0996C7.68108 12.0996 7.37587 11.9731 7.15084 11.7481C6.92581 11.5231 6.79938 11.2179 6.79938 10.8996C6.79938 10.7935 6.84152 10.6918 6.91654 10.6168C6.99155 10.5418 7.09328 10.4996 7.19936 10.4996C7.62369 10.4996 8.03063 10.3311 8.33068 10.031C8.63072 9.731 8.79928 9.32405 8.79928 8.89972Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6268_18860",
    x1: 16.6648,
    y1: 9.83008,
    x2: 16.6648,
    y2: 24.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6268_18860",
    x1: 9.59821,
    y1: 0.5,
    x2: 9.59821,
    y2: 19.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3969E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D2AE7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6268_18860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconicQuotes);
export default __webpack_public_path__ + "static/media/iconicQuotes.c6567a3b492fc6e60c592b07ab587f17.svg";
export { ForwardRef as ReactComponent };